<template>
    <v-dialog persistent
              v-if="isTransmitting"
              v-model="dialog"
              width="500"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-if="isError"
                class="ml-2"
                :class="buttonClass"
                v-bind="attrs"
                v-on="on"
                icon>
                <v-icon  :color="loadingColor">ordermanager-danger</v-icon>
            </v-btn>
            <v-btn v-else
                class="ml-2"
                :class="buttonClass"
                v-bind="attrs"
                v-on="on"
                icon>
                <v-progress-circular
                    indeterminate
                    width="1"
                    :color="loadingColor"
                >
                    <!--                    <v-img :src="uploadIcon" style="top: 6px;left: 6px;" />-->
                    <v-icon small>ordermanager-input-output</v-icon>
                </v-progress-circular>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                {{ dialogTitle }}
            </v-card-title>
            <v-card-text>
                <v-container>
                    <b>{{ dialogInfoText }}</b>
                </v-container>
                <v-progress-linear indeterminate :color="loadingColor"/>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false">
                    Ok
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {ScalesRestRepository} from "@/modules/scales/adapter/rest/ScalesRestRepository";
import {globalEventBus} from "@/main";


@Component({components: {}})
export default class UploadButton extends Vue {
    @Prop({default: 'Übertragung läuft'})
    private title!: string;
    @Prop({default: ''})
    private buttonClass!: string;
    @Prop({default: false})
    private light!: boolean;
    @Prop({default: false})
    private isTransmitting!: boolean;
    @Prop({default: 1})
    private connectionState!: number;

    private dialog: boolean = false;

    private get loadingColor(): string {
        switch (this.connectionState) {
            case 3:
                return "error";
            case 0:
                return "error";
            default:
                return "info";
        }
    }

    private get isError(): boolean {
        return this.connectionState === 3 || this.connectionState === 0;
    }
    private get dialogTitle(): string {
        if (this.title) {
            return this.title;
        }
        return "Übertragung"
    }

    private get dialogInfoText(): string {
        // nicht verbunden=0,
        // inaktiv=1,
        // aktiv=2,
        // Connect-Dienst nicht bereit=3
        if (this.isTransmitting) {
            const value = this.connectionState;
            switch (value) {
                case 3:
                    return "Der APRO.CON Connect-Dienst ist nicht bereit.";
                case 2:
                    return "Eine Übertragung läuft...";
                case 1:
                    return "Eine Übertragung läuft...";
                case 0:
                    return "Der APRO.CON Connect-Dienst ist nicht verbunden."
                case -1:
                    return "Eine Übertragung wurde gestartet."
            }
        }
        return "";
    }

    @Watch('isTransmitting')
    private async isTransmittingChanged(): Promise<void> {
        if (this.dialog && !this.isTransmitting) {
            this.dialog = false;
        }
    }
}
</script>

